import { Box, Popover, PopoverProps } from '@mantine/core';
import cx from 'clsx';
import { ReactNode, useState } from 'react';

import classes from './ColorPickerPopover.module.scss';
import { ColorType } from '../../../types/ColorPicker';
import { rem } from '../../../utils/rem';
import { ColorPicker } from '../ColorPicker';
import { ColorPickerSolid } from '../ColorPickerSolid';

type ColorPickerPopoverProps = {
  color: string;
  onSelectColor: ({ color, type }: { color: string; type: ColorType }) => void;
  withGradient?: boolean;
  themeColors: string[];
  editComponent: ReactNode;
  renderPopoverTarget: ({
    onClick,
    onSelectColor,
    color,
    selected
  }: {
    onClick: () => void;
    onSelectColor: (color: string) => void;
    color: string;
    selected: boolean;
  }) => ReactNode;
} & PopoverProps;

export function ColorPickerPopover(props: ColorPickerPopoverProps) {
  const {
    color,
    onSelectColor,
    withGradient = false,
    themeColors,
    editComponent,
    renderPopoverTarget,
    ...popoverProps
  } = props;
  const [opened, setOpened] = useState(false);

  return (
    <Popover
      opened={opened}
      onClose={() => setOpened(false)}
      position="bottom-start"
      width={rem(274)}
      {...popoverProps}
      withinPortal={false}
    >
      <Popover.Target>
        <Box>
          {renderPopoverTarget({
            onClick: () => setOpened(prev => !prev),
            onSelectColor: (color: string) => onSelectColor({ type: ColorType.solid, color }),
            color,
            selected: opened
          })}
        </Box>
      </Popover.Target>
      <Popover.Dropdown className={cx(classes.popoverDropdown, { [classes.withGradient]: withGradient })}>
        {withGradient ? (
          <ColorPicker
            themeColors={themeColors}
            color={color}
            onSelectColor={onSelectColor}
            withGradient={withGradient}
            editComponent={editComponent}
          />
        ) : (
          <ColorPickerSolid
            themeColors={themeColors}
            color={color}
            onSelectColor={(color: string) => onSelectColor({ type: ColorType.solid, color })}
            withGradient={withGradient}
            editComponent={editComponent}
          />
        )}
      </Popover.Dropdown>
    </Popover>
  );
}
